<template>
  <div class>
    <drawer :title="addEditTitle" :dialogShow="addEditShow" @handleChange="back">
      <div slot="body">
        <div class="pay-mains">
          <div class="member-msg">
            <div class="member-border">
              <el-avatar class="img" shape="circle" size="small" v-if="memberList.headImgUrl" :src="memberList.headImgUrl"></el-avatar>
              <el-avatar shape="circle" size="small" v-else :src="headerImg"></el-avatar>
              <div class="rows member-box">
                <p>{{ memberList.nickName }}</p>
                <div class="flex-row mt5">
                  <p class="mobile">{{ memberList.mobile ? '手机号码:' : '身份证号码:'}} {{ memberList.mobile ? memberList.mobile : memberList.idCardNo}}</p>
                  <p>可用余额: <span class="fontSize18">￥{{ memberList.walletAmount }}</span></p>
                  <p class="ml20">可用积分: <span class="fontSize18">{{ memberList.integralAmount }}</span></p>
                </div>
              </div>
            </div>
          </div>
            <p class="order-title-boxs"><span class="blueBlock"></span><i>兑换信息</i></p>
            <div class="totals-box pl24">
            <div class="flex-row mb30">
              <div class="itemName">商品数量</div>
              <div class="itemNum">{{ form.itemNum }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">消耗积分</div>
              <div class="itemNum moneys">{{ form.integralAmount }}积分</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">商品原价</div>
              <div class="itemNum ">￥{{ form.itemAmount }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">兑换时间</div>
              <div class="">{{ formatDate(form.payTime) }}</div>
            </div>
          </div>
          <p class="order-title-boxs"><span class="blueBlock"></span><i>兑换明细</i></p>

          <div class="totals-box mlr24">
            <el-row class="order-details">
              <el-col :span="16" class="pl10">商品名称</el-col>
              <el-col :span="3">数量</el-col>
              <el-col :span="5" class="tRight pr10">扣除</el-col>
            </el-row>
            <el-row v-for="(item,index) in form.integralOrderItemList" :key="index" class="mt20">
              <el-col :span="16" class="pl10">{{item.itemName}}</el-col>
              <el-col :span="3" class="color999">{{item.itemNum}}</el-col>
              <el-col :span="5" class="tRight pr10">￥{{item.itemPrice}}</el-col>
              <el-col :span="12" class="pl10 mt20 color999">兑换积分</el-col>
              <el-col :span="12" class="mt20 tRight pr10">
                  <div class="moneys">{{item.integralPrice}}积分</div>
              </el-col>
              <el-col :span="4" class="pl10 mt20 color999">技师</el-col>
              <el-col :span="20" class="mt20 tRight pr10">
                  <div class="jishi">{{item.staffNames}}</div>
              </el-col>
            </el-row>
          </div>
          <div v-if="form.integralAchievementList != 0">
            <p class="order-title-boxs"><span class="blueBlock"></span><i>提成明细</i></p>
            <div class="totals-box customTable">
              <div class="detail plr16">
                <el-table :data="form.integralAchievementList" input-large header-cell-class-name="table_header_bgcolor">
                  <el-table-column prop="staffName" label="店员姓名" width="80"></el-table-column>
                  <el-table-column prop="itemName" label="商品信息" width="auto"></el-table-column>
                  <el-table-column prop="achievementTotalAmount" label="业绩" width="80">
                    <template slot-scope="scope">
                        ￥{{scope.row.achieveAmount}}
                    </template>
                  </el-table-column>
                  <el-table-column prop="deductTotalAmount" label="提成" width="80">
                    <template slot-scope="scope">
                      ￥{{scope.row.achieveDeductAmount}}
                    </template>
                  </el-table-column>
                  <el-table-column label="登记时间" width="100">
                    <template slot-scope="scope">{{ formatDay(scope.row.oxCtime)}}</template>
                  </el-table-column>
                  <el-table-column label="订单类型" width="80">
                    <template slot-scope="scope">积分兑换</template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
        </div>
      
        <div class="drawer-footer pr24 pb10">
          <el-button @click="back">返回</el-button>
        </div>
      </div>
    </drawer>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import drawer from "../../../components/common/drawer";
import Dialog from "../../../components/common/dialog.vue";
export default {
  mixins: [minxin],
  components: {
    drawer,
    Dialog,
  },
  props: {
      typeCate: {
          type: String,
          default: 'reserve'
      }
  },
  data() {
    return {
      addEditShow: false,
      addEditTitle: "兑换详情",
      dialogHide: false,
      refundForm: {},
      orderInvalidForm: {},
      merchantAppMemberVO: {},
      form: {
        orderType: ""
      },
      headerImg: require("../../../assets/images/headerImg.png"),
      dialogHide: false,
      updateDeductHide: false, //修改提成
      setDeductAmount: 0,
      deductStaffList: [
        {
          deductAmount: null,
          staffName: "",
          staffId: ""
        }
      ], //提成列表
      refundList: [],
      deductInfo: [],
      memberList: {}
    };
  },
  created() {
    
    this.init();
  },
  mounted() {
    
  },
  methods: {
    handleChangePay(org) {
        console.log(org);
      if (org) {
        this.$api.get(this.$url.orderInfo.get, {id: this.form.id}).then(res => {
            if (res) {
              this.addEditShow = true;
              this.form = res;
              //this.merchantAppMemberVO = this.form.merchantAppMemberVO;
            }
          }).catch(error => {});
      }
    },
    //  页面初始化函数
    init() {
      this.$on("set", function(org) {
        this.$api.get(this.$url.integralItem.get, {
            id: org
          }).then(res => {
            if (res) {
              console.log(res);
              this.addEditShow = true;
              this.form = res;
              this.form.orderTime = this.formatDate(this.form.orderTime);
              this.form.payTime = this.formatDate(this.form.payTime);
              this.form.oxCtime = this.formatDate(this.form.oxCtime);
              this.merchantAppMemberVO = this.form.orderMemberVO;
              //this.merchantAppMemberVO = this.form.merchantAppMemberVO;
              this.getUserInfo();
            }
          }).catch(error => {});
      });
    },
    getUserInfo () {
      console.log(this.form.memberId);
      this.$api.get(this.$url.member.get, {
            id: this.form.memberId,
            needIntegralFlag: true
        }).then(ret => {
          this.memberList = ret;
        })
    },
    back() {
      this.addEditShow = false;
      this.$emit("change", false);
    }
  }
};
</script>
<style>
.payway-success .el-button + .el-button {
  margin-left: 0;
}
</style>
<style scoped lang="less">
@import "../../../assets/css/edit.less";
/deep/ div .el-drawer__body {
  padding: 0 !important;
}
.pay-mains {
  .order-details {
    height: 56px;
    line-height: 56px;
    background: #F7F8FA;
  }
}
.member-msg {
  padding: 16px 16px 0;
  .member-border {
    width: 100%;
    background-size: 100% 100%;
    color: white;
    display: flex;
    align-items: center;
    border-radius: 10px;
    padding: 12px 15px;
    background: #3388ff;
    box-sizing: border-box;
    .member-box {
      margin-left: 10px;
      .mobile {
        line-height: 1.6;
        margin-right: 20px;
      }
    }
  }
}
</style>